var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"padding-bottom":"0","margin":"0 auto"},attrs:{"type":"text"},on:{"click":_vm.handlePrintImage}},[_vm._v("打印")])
}
var staticRenderFns = []

export { render, staticRenderFns }